<template>
    <v-select
        dense
        outlined
        v-bind="$attrs"
        :items="items"
        item-text="value"
        item-value="id"
        hide-details="auto"
        clearable
        v-on="$listeners"
    />
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'ScheduleStatusSelect',

    computed: {
        ...mapState('schedule_status', {
            loaded: 'loaded',
            collection: 'collection',
        }),

        items() {
            // here we could filter the models, if needed
            return this.collection ? this.collection.models : [];
        },
    },

    mounted() {
        this.loadData();
    },

    methods: {
        ...mapActions('schedule_status', {
            loadData: 'load',
        }),
        reload() {
            this.loadData({ force: true });
        },
    },
};
</script>
